exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-container[data-v-5dca9b02] {\n  padding-top: 15px;\n}\n.codes-table[data-v-5dca9b02] {\n  width: 100%;\n}\n.codes-table td[data-v-5dca9b02] {\n    font-size: 13px;\n    line-height: 18px;\n    padding: 8px;\n}\n.codes-table .codes-first-column[data-v-5dca9b02] {\n    font-weight: 700;\n}\n.btn-container[data-v-5dca9b02] {\n  display: flex;\n  justify-content: flex-end;\n}\n", ""]);

// exports
